import { Icon, Portal } from '@instinet-analytics/semantic-ui-components';
import { useOnEscape } from '@instinet-analytics/core-lib';
import React, {
    CSSProperties,
    PropsWithChildren,
    useRef,
    useState,
} from 'react';
import './HelpPortal.scss';
import classNames from 'classnames';

export type HelpPortalProps = PropsWithChildren<{
    className?: string;
    width: number;
    height: number;
    left: number;
}>;

export function HelpPortal(props: HelpPortalProps) {
    const { className, left: leftProps, width, height, children } = props;

    const ref = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState(false);
    const [portalStyles, setPortalStyles] = useState<CSSProperties>({});

    const show = () => setOpen(true);
    const hide = () => setOpen(false);
    useOnEscape(hide);

    const onPortalMount = () => {
        if (!ref) {
            return;
        }
        const node = ref.current!;
        if (!node) {
            return;
        }
        const { top, left } = node.getBoundingClientRect();

        const popupTop = top + 20;
        const popupLeft = left + leftProps;

        setPortalStyles({ top: popupTop, left: popupLeft, width, height });
    };

    const cssClasses = classNames('HelpPortal', className);

    return (
        <div className={cssClasses} ref={ref}>
            <Portal
                onMount={() => onPortalMount()}
                trigger={
                    <div className="IconTooltipContainer">
                        <div className="icontooltip-icon">
                            <Icon name="question" />
                        </div>
                    </div>
                }
                open={open}
                onOpen={show}
                onClose={hide}
            >
                <div className="HelpPortal-content" style={portalStyles}>
                    <Icon name="close" onClick={open ? hide : show} />
                    {children}
                </div>
            </Portal>
        </div>
    );
}
